(function () {
  class systemSettingsBox extends PIXI.Container {
    constructor() {
      super();
      const self = this;
    }

    showsystemSettingsBoxPanel(show) {
      this.visible = show;
    }

    init() {}

    onReady() {
      this.visible = false;
      this._initialised = true;
    }
  }

  systemSettingsBoxCreate = function (json) {
    return new systemSettingsBox();
  };

  systemSettingsBoxInitialise = function (json, systemSettingsBoxObject) {
    Reflex.registerEventHandler(
      "ready",
      systemSettingsBoxObject.onReady.bind(systemSettingsBoxObject)
    );
  };

  systemSettingsBoxFilesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "systemSettingsBox",
    systemSettingsBoxCreate,
    systemSettingsBoxInitialise,
    systemSettingsBoxFilesRequired
  );
})();
